import {
  LOAD_PAYMENTS,
} from './constants';

export function loadPayments(id) {
  return {
    type: LOAD_PAYMENTS,
    id,
  };
}



/** WEBPACK FOOTER **
 ** ./src/containers/payments/actions.js
 **/